// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"7af460a2","403":"c0d5cb0a","510":"dbb58abb","752":"28a7cf89"}[chunkId] + ".chunk.css";
};